// 隐私协议相关
import request from '@/utils/http.js';

/**
 * 获取隐私协议信息
 *   http://yapi.vhall.domain/project/101/interface/api/58975
 * */
function getPrivacyAgreement(params = {}) {
  const url = '/v3/interacts/agreement/get-privacy-agreement'
  return request({
    url,
    method: 'GET',
    params: params
  });
}
/**
 * 保存隐私协议
 * http://yapi.vhall.domain/project/101/interface/api/58982
 * */
function savePrivacyAgreement(params = {}) {
  const url = '/v3/interacts/agreement/save-privacy-agreement'
  return request({
    url,
    method: 'POST',
    data: params
  });
}

export default {
  getPrivacyAgreement,
  savePrivacyAgreement
};